module.exports = __webpack_public_path__ + "static/media/ArmaturaPoweredBy.6c14b23f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ArmaturaPoweredBy.png
// module id = 1341
// module chunks = 0